
import LpInput from '@/app/ui/components/lp-input/index.vue';
import { Options, Vue, prop } from 'vue-class-component';


class Props {
  modelValue = prop<boolean>({
    type: Boolean,
    default: false
  });
}

@Options({
  emits: ["update:modelValue", "onCheckIssue"],
  components: { }
})

export default class ModalCheckIssue extends Vue.with(Props) {

  sttNumber = ""

  get isCheckDisable() {
    return !this.sttNumber
  }

  set openDialog(value: boolean) {
    this.$emit("update:modelValue", value)
  }

  get openDialog() {
    return this.modelValue
  }

  cancelPopup() {
    this.sttNumber = ""
    this.$emit("update:modelValue");
  }

  onCheckIssue() {
    this.$emit("onCheckIssue", this.sttNumber);
  }

  onChangeSttNumber(value: string) {
    this.sttNumber = value
  }
  
}
